export default __webpack_public_path__ + "windows5753d6.png";